import React from 'react';
import { Box, Text, TextButton } from '@wix/design-system';
import { RefreshSmall } from '@wix/wix-ui-icons-common/lazy';
import { DomainSearchSuiteModule } from '../../module/domainSearchSuite.module';
export const NetworkIssue = _ref => {
  let {
    onRetry
  } = _ref;
  const {
    t
  } = DomainSearchSuiteModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "13px",
    align: "center",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "thin"
  }, t('domain_search_suite.error.connection_issue.full_page.text')), /*#__PURE__*/React.createElement(TextButton, {
    onClick: onRetry,
    size: "tiny",
    prefixIcon: /*#__PURE__*/React.createElement(RefreshSmall, null)
  }, t('domain_search_suite.error.connection_issue.full_page.cta')));
};
//# sourceMappingURL=NetworkIssue.js.map